<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { marked } from 'marked';
import { $fetch } from '@/home/plugins/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { t, locale } = useI18n();

marked.use({
  renderer: {
    link(token) {
      const html = marked.Renderer.prototype.link.call(this, token);
      return html.replace(/^<a /, '<a target="_blank" ');
    },
  },
});

const projectStepList =  [
  {
    title: t('cooperation.projectDonate.projectStepList.title2'),
    desc: t('cooperation.projectDonate.projectStepList.desc2'),
    width: 160,
  },
  {
    title: t('cooperation.projectDonate.projectStepList.title3'),
    desc: t('cooperation.projectDonate.projectStepList.desc3'),
    width: 160,
  },
  {
    title: t('cooperation.projectDonate.projectStepList.title4'),
    desc: t('cooperation.projectDonate.projectStepList.desc4'),
    width: 144,
  },
  {
    title: t('cooperation.projectDonate.projectStepList.title5'),
    desc: t('cooperation.projectDonate.projectStepList.desc5'),
    width: 144,
  },
  {
    title: t('cooperation.projectDonate.projectStepList.title6'),
    desc: t('cooperation.projectDonate.projectStepList.desc6'),
    width: 112,
  },
]

const { data: globalConfig } = useAsyncData('cooperation:config', () => $fetch('/web/openatom/config/v1/getone'));
</script>

<template>
  <section class="page-cooperation-project bg-white pb-[48px]">
    <h3 class="m-0 pb-[48px] pt-[48px] text-center text-[32px] font-medium <md:text-24">{{ $t('cooperation.projectDonate.title') }}</h3>
    <div class="page-cooperation-project-main mx-auto w-[1360px] rounded-t-[4px] px-[80px] pt-[48px] <2xl:w-1200px <xl:w-full <xl:px-24 <md:px-16 <md:pt-8">
      <div class="mb-[32px] w-full">
        <!-- <img src="@/home/assets/cooperation/project-donate.png" class="h-full w-[560px] <2xl:w-480px" alt="">  -->
        <div class="m-0 w-full p-0">
          <!-- eslint-disable vue/no-v-html -->
          <div
            class="project-donate-desc m-0 text-16 text-white font-normal leading-24"
            v-html="marked.parse(globalConfig.configInfo.cooperation?.project?.desc1?.[locale])"
            v-if="globalConfig?.configInfo.cooperation"
          >
          </div>
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </div>
      <div class="rounded-[4px] bg-white px-[80px] py-[48px] shadow-[0px_0px_60px_0px_rgba(17,128,255,0.1)] <md:px-16 <md:py-32">
        <h4 class="m-0 p-0 font-normal">{{ $t('cooperation.projectDonate.subTitle') }}</h4>

        <div class="page-cooperation-project-main__table <md:overflow-x-auto">
          <table class="rounded-corners w-full <md:min-w-600px">
            <thead>
              <tr>
                <th width="25%">{{ $t('cooperation.projectDonate.table.head1') }}</th>
                <th width="35%">{{ $t('cooperation.projectDonate.table.head2') }}</th>
                <th>{{ $t('cooperation.projectDonate.table.head3') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="6">{{ $t('cooperation.projectDonate.table.category1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub2.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub2.children.content1') }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('cooperation.projectDonate.table.category1.children.sub3.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub3.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub3.children.content2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub4.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub4.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub5.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category1.children.sub5.children.content1') }}</td>
              </tr>
              <tr>
                <td rowspan="12">{{ $t('cooperation.projectDonate.table.category2.title') }}</td>
                <td rowspan="7">{{ $t('cooperation.projectDonate.table.category2.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub1.children.content2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub1.children.content3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub1.children.content4') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub1.children.content5') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub1.children.content6') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub1.children.content7') }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('cooperation.projectDonate.table.category2.children.sub2.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub2.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub2.children.content2') }}</td>
              </tr>
              <tr>
                <td rowspan="3">{{ $t('cooperation.projectDonate.table.category2.children.sub3.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub3.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub3.children.content2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category2.children.sub3.children.content3') }}</td>
              </tr>
              <tr>
                <td rowspan="7">{{ $t('cooperation.projectDonate.table.category3.title') }}</td>
                <td rowspan="2">{{ $t('cooperation.projectDonate.table.category3.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category3.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category3.children.sub1.children.content2') }}</td>
              </tr>
              <tr>
                <td rowspan="3">{{ $t('cooperation.projectDonate.table.category3.children.sub2.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category3.children.sub2.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category3.children.sub2.children.content2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category3.children.sub2.children.content3') }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('cooperation.projectDonate.table.category3.children.sub3.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category3.children.sub3.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category3.children.sub3.children.content2') }}</td>
              </tr>
              <tr>
                <td rowspan="3">{{ $t('cooperation.projectDonate.table.category4.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category4.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category4.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category4.children.sub2.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category4.children.sub2.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category4.children.sub3.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category4.children.sub3.children.content1') }}</td>
              </tr>
              <tr>
                <td rowspan="3">{{ $t('cooperation.projectDonate.table.category5.title') }}</td>
                <td rowspan="3">{{ $t('cooperation.projectDonate.table.category5.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category5.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category5.children.sub1.children.content2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category5.children.sub1.children.content3') }}</td>
              </tr>
              <tr>
                <td rowspan="4">{{ $t('cooperation.projectDonate.table.category6.title') }}</td>
                <td rowspan="2">{{ $t('cooperation.projectDonate.table.category6.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category6.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category6.children.sub1.children.content2') }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('cooperation.projectDonate.table.category6.children.sub2.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category6.children.sub2.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category6.children.sub2.children.content2') }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('cooperation.projectDonate.table.category7.title') }}</td>
                <td rowspan="2">{{ $t('cooperation.projectDonate.table.category7.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category7.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category7.children.sub1.children.content2') }}</td>
              </tr>
              <tr>
                <td rowspan="7">{{ $t('cooperation.projectDonate.table.category8.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td rowspan="3">{{ $t('cooperation.projectDonate.table.category8.children.sub2.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub2.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub2.children.content2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub2.children.content3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub3.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub3.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub4.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub4.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub5.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category8.children.sub5.children.content1') }}</td>
              </tr>
              <tr>
                <td rowspan="2" class="last">{{ $t('cooperation.projectDonate.table.category9.title') }}</td>
                <td rowspan="2" class="last">{{ $t('cooperation.projectDonate.table.category9.children.sub1.title') }}</td>
                <td>{{ $t('cooperation.projectDonate.table.category9.children.sub1.children.content1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('cooperation.projectDonate.table.category9.children.sub1.children.content2') }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h4 class="m-0 mb-[24px] mt-[48px] p-0 text-[24px] font-normal <md:text-20">{{ $t('cooperation.projectDonate.projectStepTitle') }}</h4>
        <div class="mb-8px h-52px w-743px bg-[url(@/home/assets/cooperation/welfare-steps.png)] bg-contain bg-no-repeat <md:hidden"></div>
        <ul class="m-0 flex list-none items-start justify-start p-0 <md:flex-wrap">
          <li v-for="(item, index) in projectStepList" :key="index" class="project-step-item mr-[28px] w-144px flex shrink-0 flex-col justify-start <md:mb-16 <md:mr-0 <md:w-full">
            <span class="mb-4px inline-block w-full text-[16px] font-medium leading-[24px]">{{ item.title }}</span>
            <span class="inline-block w-full text-[14px] font-normal leading-[22px]">{{ item.desc }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-cooperation-project {
  color: #2d2d2d;

  &-main {
    background: url(@/home/assets/cooperation/project-donate-bg.svg) no-repeat;
    background-size: 1360px 1200px;

    h4 {
      height: auto;
      line-height: 1.4;
    }

    .project-donate-desc:deep(a) {
      color: #fff;
      font-weight: 700;
      font-size: 18px;

      &:hover {
        opacity: .9;
      }
    }

    .page-cooperation-project-main__table {
      margin-top: 24px;

      .rounded-corners {
        --border: 1px solid #1180ff;
        overflow: hidden;
        border: var(--border);
        border-radius: 4px;
        border-collapse: separate;
        border-spacing: 0;

        th:not(:last-child),
        td:not(:last-child) {
          border-right: var(--border);
        }

        > thead > tr:not(:last-child) > th,
        > thead > tr:not(:last-child) > td,
        > tbody > tr:not(:last-child) > th,
        > tbody > tr:not(:last-child) > td:not(.last),
        > tfoot > tr:not(:last-child) > th,
        > tfoot > tr:not(:last-child) > td,
        > tr:not(:last-child) > td,
        > tr:not(:last-child) > th,
        > thead:not(:last-child),
        > tbody:not(:last-child),
        > tfoot:not(:last-child) {
          border-bottom: var(--border);
        }
      }

      table {
        th {
          height: 56px;
          color: #fff;
          font-size: 24px;
          word-break: break-all;
          background-color: #1180ff;

          @apply font-medium;
        }

        td {
          font-size: 16px;
          line-height: 1.4;

          @apply text-center p-10px;
        }
      }
    }
  }

  // 响应式：断点值与 uno.config 一致（md=768px）
  @media (max-width: 767.9px) {
    &-main {
      .page-cooperation-project-main__table {
        table {
          th {
            height: 44px;
            font-size: 16px;
          }

          td {
            font-size: 13px;

            @apply p-6px;
          }
        }
      }

      .project-step-item {
        position: relative;
        padding-left: 40px;

        &::before {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          color: #fff;
          font-weight: 600;
          font-size: 14px;
          line-height: 28px;
          text-align: center;
          background-color: #1180ff;
          border-radius: 50%;
          content: counter(step-counter);
          counter-increment: step-counter;
        }

        &::after {
          position: absolute;
          top: 32px;
          bottom: -16px;
          left: 13px;
          width: 2px;
          background: linear-gradient(to bottom, #1180ff, rgba(17, 128, 255, 0.2));
          content: "";
        }

        &:last-child::after {
          display: none;
        }
      }

      ul:has(.project-step-item) {
        counter-reset: step-counter;
      }
    }
  }
}
</style>
